<div id="banner" class="banner">
    <!-- Desktop version - single line -->
    <div class="d-none d-md-block">
    <strong>Limited Time!</strong><br />
    $50 off Annual Premium Membership + 3 Free Months on Select Annual Leases!
    </div>
    <!-- Mobile version - with line breaks -->
    <div class="d-block d-md-none">
    <strong>Limited Time!</strong><br />
    $50 off Annual Premium Membership<br /> + 3 Free Months on Select Annual Leases!
    
    </div>
</div>